App.Basket = DS.Model.extend
  buddies   : DS.hasMany 'buddy', async : true
